import { useAccountLogo } from 'hooks/account.hooks';
import React from 'react';
import { useTranslation } from 'react-i18next';

const AccountLogo: React.FC = () => {
  const { show, imageUrl, handleError } = useAccountLogo();
  const { t } = useTranslation();

  if (!show || !imageUrl) return null;

  return (
    <>
      <div aria-hidden className="w-px h-7 bg-color-border" />
      <img
        src={imageUrl}
        alt={t('global:account_logo_alt')}
        className="max-h-8 h-8 w-auto block object-contain"
        onError={handleError}
      />
    </>
  );
};

export default AccountLogo;
